import UserContext from "Context/UserProvider";
import BusinessLocationsWithChargingTable from "components/business/InfrastructureComponent/BusinessLocationsWithChargingTable";
import { useContext, useEffect, useState } from "react";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function BusinessDwellingListPage(props: any) {
    const { userInfo, setUserInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [loading, setLoading] = useState(true);
    const [businessLocationsData, setBusinessLocationsData] = useState([]) as any;
    const [showCategory, setShowCategory] = useState([true]);
    const [activeMenu, setActiveMenu] = useState("Business Locations");

    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    async function fetchLocationData() {
        try {
            const response = await fetchWithAuth('/infrastructure/dwelling/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                console.error('Failed to fetch location data:', response.status);
                return;
            }

            const res_json = await response.json();
            res_json.businessLocations = checking_null_undefined(res_json.businessLocations);

            setBusinessLocationsData(res_json.businessLocations.map((e: any) => ({ 
                ...e, 
                id: e.uuid, 
                businessUuid: e.businessUuid 
            })));
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchLocationData();
    }, []);

    if (loading) return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress />
        </Box>
    );

    return (
        <div className="drag-drop-container">
            <BusinessLocationsWithChargingTable data={businessLocationsData} />
        </div>
    );
}

export default BusinessDwellingListPage;
